export default [
  {
    code: 'ZWL',
    name: 'Zimbabwean dollar ',
    countries: ['ZW'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'RSD',
    name: 'Serbian dinar ',
    countries: ['RS'],
    symbols: { prefix: 'din.', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'TJS',
    name: 'Tajikistani somoni ',
    countries: ['TJ'],
    symbols: { prefix: '', suffix: 'SM' },
    fixedDigits: 2,
  },
  {
    code: 'GEL',
    name: 'Georgian lari ',
    countries: ['GE'],
    symbols: { prefix: 'GEL', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'MGA',
    name: 'Malagasy ariary ',
    countries: ['MG'],
    symbols: { prefix: 'Ar', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'UZS',
    name: 'Uzbekistani som ',
    countries: ['UZ'],
    symbols: { prefix: 'UZS', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'CDF',
    name: 'Congolese franc ',
    countries: ['CD'],
    symbols: { prefix: 'Fr', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'SRD',
    name: 'Surinamese dollar ',
    countries: ['SR'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'AFN',
    name: 'Afghan afghani ',
    countries: ['AF'],
    symbols: { prefix: '؋', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'AMD',
    name: 'Armenian dram ',
    countries: ['AM'],
    symbols: { prefix: 'AMD', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'AOA',
    name: 'Angolan kwanza ',
    countries: ['AO'],
    symbols: { prefix: 'Kz', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'AZN',
    name: 'Azerbaijani manat ',
    countries: ['AZ'],
    symbols: { prefix: 'MAN', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'MZN',
    name: 'Mozambican metical ',
    countries: ['MZ'],
    symbols: { prefix: 'MT', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'SVC',
    name: 'El Salvador Colon ',
    countries: ['SV'],
    symbols: { prefix: '₡', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'BMD',
    name: 'Bermudian Dollar ',
    countries: ['BM'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'BTN',
    name: 'Bhutan Ngultrum ',
    countries: ['BT'],
    symbols: { prefix: 'Nu', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'BOB',
    name: 'Bolivian Boliviano ',
    countries: ['BO'],
    symbols: { prefix: 'Bs.', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'BWP',
    name: 'Botswana Pula ',
    countries: ['BW'],
    symbols: { prefix: 'P', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'BRL',
    name: 'Brazilian Real ',
    countries: ['BR'],
    symbols: { prefix: 'R$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'BND',
    name: 'Brunei Dollar ',
    countries: ['BN'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'BGN',
    name: 'Bulgarian Lev ',
    countries: ['BG'],
    symbols: { prefix: '', suffix: 'лв.' },
    fixedDigits: 2,
  },
  {
    code: 'BIF',
    name: 'Burundi Franc ',
    countries: ['BI'],
    symbols: { prefix: 'Fr', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'CAD',
    name: 'Canadian Dollar ',
    countries: ['CA'],
    symbols: { prefix: 'C$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'CNY',
    name: 'Chinese Yuan ',
    countries: ['CN'],
    symbols: { prefix: '¥', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'KHR',
    name: 'Cambodia Riel ',
    countries: ['KH'],
    symbols: { prefix: '៛', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'KGS',
    name: 'Kyrgyzstani Som ',
    countries: ['KG'],
    symbols: { prefix: 'som', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'CVE',
    name: 'Cape Verde Escudo ',
    countries: ['CV'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'KYD',
    name: 'Cayman Islands Dollar ',
    countries: ['KY'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'YER',
    name: 'Yemen Riyal ',
    countries: ['YE'],
    symbols: { prefix: '﷼', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'VND',
    name: 'Vietnam Dong ',
    countries: ['VN'],
    symbols: { prefix: '', suffix: '₫' },
    fixedDigits: 0,
  },
  {
    code: 'CLP',
    name: 'Chile Peso ',
    countries: ['CL'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'COP',
    name: 'Colombian Peso ',
    countries: ['CO'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'KMF',
    name: 'Comoros Franc ',
    countries: ['KM'],
    symbols: { prefix: 'Fr', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'DZD',
    name: 'Algerian Dinar ',
    countries: ['DZ'],
    symbols: { prefix: 'د.ج', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'CRC',
    name: 'Costa Rica Colon ',
    countries: ['CR'],
    symbols: { prefix: '₡', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'HRK',
    name: 'Croatian Kuna ',
    countries: ['HR'],
    symbols: { prefix: 'kn', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'CUP',
    name: 'Cuban Peso ',
    countries: ['CU'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'CZK',
    name: 'Czech Koruna ',
    countries: ['CZ'],
    symbols: { prefix: '', suffix: 'Kč' },
    fixedDigits: 2,
  },
  {
    code: 'VEF',
    name: 'Venezuelan Bolivar Fuerte ',
    countries: ['VE'],
    symbols: { prefix: 'Bs F', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'VES',
    name: 'Venezuelan Bolivar Soberano ',
    countries: ['VE'],
    symbols: { prefix: 'VES', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'VUV',
    name: 'Vanuatu Vatu ',
    countries: ['VU'],
    symbols: { prefix: 'Vt', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'DJF',
    name: 'Dijibouti Franc ',
    countries: ['DJ'],
    symbols: { prefix: 'Fr', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'DOP',
    name: 'Dominican Peso ',
    countries: ['DO'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'UYU',
    name: 'Uruguayan New Peso ',
    countries: ['UY'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'LRD',
    name: 'Liberian Dollar ',
    countries: ['LR'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'EGP',
    name: 'Egyptian Pound ',
    countries: ['EG'],
    symbols: { prefix: '£', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'ARS',
    name: 'Argentine Peso ',
    countries: ['AR'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'ERN',
    name: 'Eritrea Nakfa ',
    countries: ['ER'],
    symbols: { prefix: 'Nfk', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'AWG',
    name: 'Aruba Florin ',
    countries: ['AW'],
    symbols: { prefix: 'ƒ', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'ETB',
    name: 'Ethiopian Birr ',
    countries: ['ET'],
    symbols: { prefix: 'Br', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'FKP',
    name: 'Falkland Islands Pound ',
    countries: ['FK'],
    symbols: { prefix: '£', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'FJD',
    name: 'Fiji Dollar ',
    countries: ['FJ'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'HKD',
    name: 'Hong Kong Dollar ',
    countries: ['HK'],
    symbols: { prefix: 'HK$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'IDR',
    name: 'Indonesian Rupiah ',
    countries: ['ID'],
    symbols: { prefix: 'Rp', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'INR',
    name: 'Indian Rupee ',
    countries: ['IN'],
    symbols: { prefix: '₹', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'GMD',
    name: 'Gambian Dalasi ',
    countries: ['GM'],
    symbols: { prefix: 'D', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'GHS',
    name: 'Ghanian Cedi ',
    countries: ['GH'],
    symbols: { prefix: 'GHS', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'GIP',
    name: 'Gibraltar Pound ',
    countries: ['GI'],
    symbols: { prefix: '£', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'GTQ',
    name: 'Guatemala Quetzal ',
    countries: ['GT'],
    symbols: { prefix: 'Q', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'GNF',
    name: 'Guinea Franc ',
    countries: ['GN'],
    symbols: { prefix: 'Fr', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'GYD',
    name: 'Guyana Dollar ',
    countries: ['GY'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'HTG',
    name: 'Haiti Gourde ',
    countries: ['HT'],
    symbols: { prefix: 'G', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'HNL',
    name: 'Honduras Lempira ',
    countries: ['HN'],
    symbols: { prefix: 'L', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'HUF',
    name: 'Hungary Forint ',
    countries: ['HU'],
    symbols: { prefix: '', suffix: 'Ft' },
    fixedDigits: 0,
  },
  {
    code: 'ISK',
    name: 'Iceland Krona ',
    countries: ['IS'],
    symbols: { prefix: 'kr', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'IRR',
    name: 'Iran Rial ',
    countries: ['IR'],
    symbols: { prefix: '﷼', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'IQD',
    name: 'Iraqi Dinar ',
    countries: ['IQ'],
    symbols: { prefix: 'ع.د', suffix: '' },
    fixedDigits: 3,
  },
  {
    code: 'UAH',
    name: 'Ukraine Hryvnia ',
    countries: ['UA'],
    symbols: { prefix: '', suffix: 'грн.' },
    fixedDigits: 2,
  },
  {
    code: 'JPY',
    name: 'Japanese Yen ',
    countries: ['JP'],
    symbols: { prefix: '¥', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'JMD',
    name: 'Jamaican Dollar ',
    countries: ['JM'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'JOD',
    name: 'Jordanian Dinar ',
    countries: ['JO'],
    symbols: { prefix: 'د.ا', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'KZT',
    name: 'Kazakhstan Tenge ',
    countries: ['KZ'],
    symbols: { prefix: 'KZT', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'KES',
    name: 'Kenyan Shilling ',
    countries: ['KE'],
    symbols: { prefix: 'Sh', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'KWD',
    name: 'Kuwaiti Dinar ',
    countries: ['KW'],
    symbols: { prefix: 'د.ك', suffix: '' },
    fixedDigits: 3,
  },
  {
    code: 'LAK',
    name: 'Lao Kip ',
    countries: ['LA'],
    symbols: { prefix: '₭', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'BAM',
    name: 'Bosnia-Herzegovina Convertible Mark ',
    countries: ['BA'],
    symbols: { prefix: 'KM', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'LBP',
    name: 'Lebanese Pound ',
    countries: ['LB'],
    symbols: { prefix: '', suffix: 'ل.ل' },
    fixedDigits: 2,
  },
  {
    code: 'LSL',
    name: 'Lesotho Loti ',
    countries: ['LS'],
    symbols: { prefix: 'L', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'ALL',
    name: 'Albanian Lek ',
    countries: ['AL'],
    symbols: { prefix: 'L', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'LYD',
    name: 'Libyan Dinar ',
    countries: ['LY'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 3,
  },
  {
    code: 'MOP',
    name: 'Macau Pataca ',
    countries: ['MO'],
    symbols: { prefix: 'P', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'MKD',
    name: 'Macedonian Denar ',
    countries: ['MK'],
    symbols: { prefix: 'ден', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'MWK',
    name: 'Malawi Kwacha ',
    countries: ['MW'],
    symbols: { prefix: 'MK', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'MYR',
    name: 'Malaysian Ringgit ',
    countries: ['MY'],
    symbols: { prefix: 'RM', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'MVR',
    name: 'Maldives Rufiyaa ',
    countries: ['MV'],
    symbols: { prefix: 'MVR', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'BSD',
    name: 'Bahamian Dollar ',
    countries: ['BS'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'MRO',
    name: 'Mauritania Ougulya ',
    countries: ['MR'],
    symbols: { prefix: 'UM', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'MUR',
    name: 'Mauritius Rupee ',
    countries: ['MU'],
    symbols: { prefix: '₨', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'MXN',
    name: 'Mexican Peso ',
    countries: ['MX'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'MDL',
    name: 'Moldovan Leu ',
    countries: ['MD'],
    symbols: { prefix: 'L', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'MNT',
    name: 'Mongolian Tugrik ',
    countries: ['MN'],
    symbols: { prefix: '₮', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'UGX',
    name: 'Ugandan Shilling ',
    countries: ['UG'],
    symbols: { prefix: 'Sh', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'MMK',
    name: 'Myanmar Kyat ',
    countries: ['MM'],
    symbols: { prefix: 'Ks', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'NAD',
    name: 'Namibian Dollar ',
    countries: ['NA'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'NPR',
    name: 'Nepalese Rupee ',
    countries: ['NP'],
    symbols: { prefix: 'Rs', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'AED',
    name: 'UAE Dirham ',
    countries: ['AE'],
    symbols: { prefix: 'د.إ', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'TND',
    name: 'Tunisian Dinar ',
    countries: ['TN'],
    symbols: { prefix: 'د.ت', suffix: '' },
    fixedDigits: 3,
  },
  {
    code: 'NIO',
    name: 'Nicaragua Cordoba ',
    countries: ['NI'],
    symbols: { prefix: 'C$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'NGN',
    name: 'Nigerian Naira ',
    countries: ['NG'],
    symbols: { prefix: 'N', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'KPW',
    name: 'North Korean Won ',
    countries: ['KP'],
    symbols: { prefix: '₩', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'TTD',
    name: 'Trinidad &amp; Tobago Dollar ',
    countries: ['TT'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'OMR',
    name: 'Omani Rial ',
    countries: ['OM'],
    symbols: { prefix: 'ر.ع.', suffix: '' },
    fixedDigits: 3,
  },
  {
    code: 'TOP',
    name: 'Tonga Pa`ang ',
    countries: ['TO'],
    symbols: { prefix: 'T$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'PKR',
    name: 'Pakistani Rupee ',
    countries: ['PK'],
    symbols: { prefix: '', suffix: 'Rs' },
    fixedDigits: 2,
  },
  {
    code: 'BHD',
    name: 'Bahraini Dinar ',
    countries: ['BH'],
    symbols: { prefix: '‎د.ب.‏', suffix: '' },
    fixedDigits: 3,
  },
  {
    code: 'PAB',
    name: 'Panama Balboa ',
    countries: ['PA'],
    symbols: { prefix: 'B/.', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'PGK',
    name: 'Papua New Guinea Kina ',
    countries: ['PG'],
    symbols: { prefix: 'K', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'PYG',
    name: 'Paraguayan Guarani ',
    countries: ['PY'],
    symbols: { prefix: '₲', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'PEN',
    name: 'Peruvian Nuevo Sol ',
    countries: ['PE'],
    symbols: { prefix: 'S/.', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'PHP',
    name: 'Philippine Peso ',
    countries: ['PH'],
    symbols: { prefix: 'Php', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'BDT',
    name: 'Bangladesh Taka ',
    countries: ['BD'],
    symbols: { prefix: '৳', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'PLN',
    name: 'Polish Zloty ',
    countries: ['PL'],
    symbols: { prefix: '', suffix: 'zł' },
    fixedDigits: 2,
  },
  {
    code: 'QAR',
    name: 'Qatar Rial ',
    countries: ['QA'],
    symbols: { prefix: 'ر.ق', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'RON',
    name: 'Romanian New Leu ',
    countries: ['RO'],
    symbols: { prefix: '', suffix: 'LEI' },
    fixedDigits: 2,
  },
  {
    code: 'RUB',
    name: 'Russian Ruble ',
    countries: ['RU'],
    symbols: { prefix: '', suffix: 'RUB' },
    fixedDigits: 2,
  },
  {
    code: 'RWF',
    name: 'Rwanda Franc ',
    countries: ['RW'],
    symbols: { prefix: '', suffix: 'Fr' },
    fixedDigits: 2,
  },
  {
    code: 'TZS',
    name: 'Tanzanian Shilling ',
    countries: ['TZ'],
    symbols: { prefix: 'Sh', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'KRW',
    name: 'South Korean Won ',
    countries: ['KR'],
    symbols: { prefix: 'KRW', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'WST',
    name: 'Samoa Tala ',
    countries: ['WS'],
    symbols: { prefix: 'T', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'STD',
    name: 'Sao Tome Dobra ',
    countries: ['ST'],
    symbols: { prefix: 'Db', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'SAR',
    name: 'Saudi Arabian Riyal ',
    countries: ['SA'],
    symbols: { prefix: 'ر.س', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'SCR',
    name: 'Seychelles Rupee ',
    countries: ['SC'],
    symbols: { prefix: 'Rs', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'SLL',
    name: 'Sierra Leone Leone ',
    countries: ['SL'],
    symbols: { prefix: 'Le', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'BBD',
    name: 'Barbados Dollar ',
    countries: ['BB'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'SGD',
    name: 'Singapore Dollar ',
    countries: ['SG'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'BYN',
    name: 'Belarussian Ruble ',
    countries: ['BY'],
    symbols: { prefix: '', suffix: 'б.р.' },
    fixedDigits: 2,
  },
  {
    code: 'BZD',
    name: 'Belize Dollar ',
    countries: ['BZ'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'SBD',
    name: 'Solomon Islands Dollar ',
    countries: ['SB'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'SOS',
    name: 'Somali Shilling ',
    countries: ['SO'],
    symbols: { prefix: 'Sh', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'ZAR',
    name: 'South African Rand ',
    countries: ['ZA'],
    symbols: { prefix: 'R', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'LKR',
    name: 'Sri Lanka Rupee ',
    countries: ['LK'],
    symbols: { prefix: 'Rs', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'SHP',
    name: 'St Helena Pound ',
    countries: ['SH'],
    symbols: { prefix: '£', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'SDG',
    name: 'Sudanese Pound ',
    countries: ['SD'],
    symbols: { prefix: '£', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'SZL',
    name: 'Swaziland Lilageni ',
    countries: ['SZ'],
    symbols: { prefix: 'L', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'SEK',
    name: 'Sweden Krona ',
    countries: ['SE'],
    symbols: { prefix: '', suffix: 'kr' },
    fixedDigits: 2,
  },
  {
    code: 'SYP',
    name: 'Syrian Pound ',
    countries: ['SY'],
    symbols: { prefix: '£', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'TWD',
    name: 'Taiwan Dollar ',
    countries: ['TW'],
    symbols: { prefix: 'NT$', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'THB',
    name: 'Thai Baht ',
    countries: ['TH'],
    symbols: { prefix: '฿', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'TMT',
    name: 'Turkmenistan manat ',
    countries: ['TM'],
    symbols: { prefix: '', suffix: 'm' },
    fixedDigits: 2,
  },
  {
    code: 'TRY',
    name: 'Turkish Lira ',
    countries: ['TR'],
    symbols: { prefix: 'TRY', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'ILS',
    name: 'Israeli Shekel ',
    countries: ['PS', 'IL'],
    symbols: { prefix: '', suffix: '₪' },
    fixedDigits: 2,
  },
  {
    code: 'ANG',
    name: 'Neth Antilles Guilder ',
    countries: ['CW', 'SX'],
    symbols: { prefix: 'ƒ', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'MAD',
    name: 'Moroccan Dirham ',
    countries: ['EH', 'MA'],
    symbols: { prefix: 'د.م.', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'CHF',
    name: 'Swiss Franc ',
    countries: ['CH', 'LI'],
    symbols: { prefix: 'CHF', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'XPF',
    name: 'Pacific Franc ',
    countries: ['WF', 'PF', 'NC'],
    symbols: { prefix: 'XPF', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'NOK',
    name: 'Norway Krone ',
    countries: ['BV', 'SJ', 'NO'],
    symbols: { prefix: 'kr', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'DKK',
    name: 'Danish Krone ',
    countries: ['GL', 'FO', 'DK'],
    symbols: { prefix: 'kr', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'NZD',
    name: 'New Zealand Dollar ',
    countries: ['TK', 'PN', 'NZ', 'NU', 'CK'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'GBP',
    name: 'British Pound ',
    countries: ['JE', 'GS', 'GG', 'GB', 'IM'],
    symbols: { prefix: '£', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'XAF',
    name: 'CFA Franc ',
    countries: ['GQ', 'GA', 'CM', 'CG', 'CF', 'TD'],
    symbols: { prefix: 'Fr', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'XCD',
    name: 'East Caribbean Dollar ',
    countries: ['GD', 'MS', 'KN', 'DM', 'LC', 'VC', 'AG', 'AI'],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'AUD',
    name: 'Australian Dollar ',
    countries: ['HM', 'NF', 'NR', 'CC', 'CX', 'KI', 'TV', 'AU'],
    symbols: { prefix: 'AU$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'XOF',
    name: 'CFA Franc ',
    countries: ['BF', 'BJ', 'GW', 'ML', 'NE', 'CI', 'SN', 'TG'],
    symbols: { prefix: 'Fr', suffix: '' },
    fixedDigits: 0,
  },
  {
    code: 'USD',
    name: 'United States Dollar ',
    countries: [
      'BQ',
      'TL',
      'GU',
      'SV',
      'PR',
      'PW',
      'EC',
      'MH',
      'MP',
      'IO',
      'FM',
      'VG',
      'US',
      'UM',
      'TC',
      'VI',
      'AS',
    ],
    symbols: { prefix: '$', suffix: '' },
    fixedDigits: 2,
  },
  {
    code: 'EUR',
    name: 'Euro ',
    countries: [
      'BE',
      'BL',
      'RE',
      'GR',
      'GP',
      'GF',
      'PT',
      'PM',
      'EE',
      'IT',
      'ES',
      'ME',
      'MF',
      'MC',
      'MT',
      'MQ',
      'FR',
      'FI',
      'NL',
      'XK',
      'CY',
      'SK',
      'SI',
      'SM',
      'DE',
      'YT',
      'LV',
      'LU',
      'TF',
      'VA',
      'AD',
      'AT',
      'AX',
      'IE',
    ],
    symbols: { prefix: '', suffix: '€' },
    fixedDigits: 2,
  },
];
